/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./download-resource-button-popover.vue?vue&type=template&id=6ad4d4d7&scoped=true&"
import script from "./download-resource-button-popover.vue?vue&type=script&lang=js&"
export * from "./download-resource-button-popover.vue?vue&type=script&lang=js&"
import style0 from "./download-resource-button-popover.vue?vue&type=style&index=0&id=6ad4d4d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4d4d7",
  null
  
)

export default component.exports